import React, { FC, PropsWithChildren, useEffect, useRef } from 'react'
import { TextButton } from '@shared/ui/atoms'

const STEAM_VOUCHERS_SECTION_ID = 'steam-vouchers'

const ScrollToSteamVouchersButton: FC<PropsWithChildren> = ({ children }) => {
  const vouchersSectionRef = useRef<HTMLElement | null>(null)
  const headerRef = useRef<HTMLElement | null>(null)

  useEffect(() => {
    vouchersSectionRef.current = document.getElementById(STEAM_VOUCHERS_SECTION_ID)
    headerRef.current = document.getElementById('header')
  }, [])

  const handleClick = () => {
    const vouchersSection = vouchersSectionRef.current

    if (!vouchersSection) return

    const headerHeight = headerRef.current?.offsetHeight ?? 0
    const topOffset = vouchersSection.getBoundingClientRect().top + window.scrollY - headerHeight

    window.scrollTo({
      top: topOffset,
      behavior: 'smooth',
    })
  }

  return <TextButton onClick={handleClick}>{children}</TextButton>
}

export default ScrollToSteamVouchersButton
